/**
 * ansichtsModell — EINE reine Funktion, die entscheidet, WELCHE Ansicht die
 * Auswertungsseite zeigt.
 *
 * WOFÜR (Fund 22.08.2026)
 * ----------------------
 * `loadAnalytics` holt neun Endpunkte; fünf davon sind Pflicht und laufen über ein
 * gemeinsames `Promise.all`. Scheitert **einer** davon (500, Netz weg, Sitzung
 * abgelaufen), greift der `catch`, ein Toast erscheint für ein paar Sekunden — und
 * `status` bleibt `null`.
 *
 * Danach galt: `const hasData = status?.has_data` → `undefined` → falsy → die Seite
 * rendert den Leerzustand. Und der sagt:
 *
 *     „Sobald du deinen ersten Beitrag veröffentlichst, erscheinen hier Klicks,
 *      Reichweite und Interaktionen."
 *
 * Also **„du hast noch nichts veröffentlicht"** — bei einem Kunden mit 58
 * veröffentlichten Beiträgen. Ein technischer Fehler erschien als leeres Konto. Der
 * Toast war weg, der falsche Satz blieb stehen.
 *
 * Das wiegt seit dem 20.08. schwerer als vorher: Bis dahin war die Auswertung ohnehin
 * dauerhaft leer (es gab keinen Schreiber für `posting_performance`). Jetzt gibt es
 * echte Zahlen — und damit einen Unterschied zwischen „nichts da" und „nicht geladen".
 *
 * Vier Zustände, die nie verwechselt werden dürfen:
 *   laden   — wir wissen es noch nicht
 *   fehler  — wir konnten nicht nachsehen        ← fehlte
 *   leer    — wir haben nachgesehen, da ist nichts
 *   daten   — da ist etwas
 */

export const ANSICHT = {
  LADEN: "laden",
  FEHLER: "fehler",
  LEER: "leer",
  DATEN: "daten",
};

/**
 * @param {{laden?: boolean, ladefehler?: boolean, hatDaten?: boolean}} zustand
 * @returns {string} einer der ANSICHT-Werte
 */
export function ansichtsModell({ laden, ladefehler, hatDaten } = {}) {
  // Reihenfolge ist Absicht: Laden schlägt alles (sonst blitzt kurz ein Leerzustand
  // auf), und ein Fehler schlägt „leer" — denn ohne geladene Daten WISSEN wir nicht,
  // ob es leer ist. Genau diese Verwechslung war der Fehler.
  if (laden) return ANSICHT.LADEN;
  if (ladefehler) return ANSICHT.FEHLER;
  return hatDaten ? ANSICHT.DATEN : ANSICHT.LEER;
}
